/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import FormHelpers from './form-helpers';
import Helpers from './helpers';
import ErrorHandling from './error-handling';
import AsyncForm from './async-form';

const OnboardingFlow = {
	init({ el }) {
		this.currentTab = 0;
		this.tabs = document.getElementsByClassName('tab');
		this.withStepIndicator = el?.dataset?.withStepIndicator;
		this.errorMessages = [];
		this.addEventsToTabButtons(this.currentTab);
		if (this.tabs != null && this.tabs.length > 0) {
			this.showTab();
			window.addEventListener('return-false', () => {
				Helpers.enableAllButtons();
				this.continue = false;
			});
		}
	},

	addEventsToTabButtons() {
		const nextBtns = document.querySelectorAll('.btn--next');
		const prevBtns = document.querySelectorAll('.btn--prev');
		if (prevBtns.length > 0) {
			prevBtns.forEach((prevBtn) => {
				prevBtn.addEventListener('click', (e) => {
					e.preventDefault();
					this.nextPrev(-1, this.tabs[this.currentTab]);
				});
			});
		}
		if (nextBtns.length > 0) {
			nextBtns.forEach((nextBtn) => {
				nextBtn.addEventListener('click', (e) => {
					e.preventDefault();
					if (FormHelpers.missingInputCheck(this.tabs[this.currentTab], e)) {
						if (this.currentTab === this.tabs.length - 1) {
							this.submitForm(this.tabs[this.currentTab]);
							window.location.href = e.target?.dataset?.redirectPage;
						} else {
							this.nextPrev(1, this.tabs[this.currentTab]);
						}
					}
				});
			});
		}
	},

	submitForm(form) {
		this.continue = true;
		if (form.dataset?.apiEndpoint) {
			Helpers.disableAllButtons();
			const formSubmit = new AsyncForm({ elements: [form] });
			const submitResponse = formSubmit.handleFormSubmit({
				element: form,
			});

			this.continue = submitResponse;
		}
		return this.continue;
	},

	showTab() {
		const currentTabContainer = this.tabs[this.currentTab];
		const hash = currentTabContainer?.dataset?.url;
		if (hash) window.history.replaceState(null, null, `#${hash}`);
		currentTabContainer.style.display = 'grid';

		// Check if any skillclusters are selected, if not show all skillclusters with skills
		this.checkSkillClustersSelect(currentTabContainer);

		// set the progressbar
		const progressBar = currentTabContainer.querySelector('.progress-bar--form');
		if (progressBar) {
			FormHelpers.setProgressBar(progressBar, this.currentTab, this.tabs);
		}

		Helpers.scrollTo(300);
		// ... and run a function that displays the correct step indicator:
		if (this.currentTab > 0) {
			if (this.withStepIndicator) {
				this.fixStepIndicator();
			}
		}
		if (currentTabContainer.querySelector('.causes-select-all')) {
			currentTabContainer.querySelector('.causes-select-all').addEventListener('click', (e) => {
				e.preventDefault();
				this.selectAllCheckboxes(e, this.tabs[this.currentTab]);
			});
		}

		if (document.querySelectorAll('.wizard__counter').length > 0) {
			FormHelpers.tabCounter(this.tabs.length, this.currentTab);
		}
	},

	checkSkillClustersSelect(currentTabContainer) {
		let skillClusterSelected = 0;
		// Check if any skillclusters are selected
		// TODO: fix issue skillclusters all showing after going back and forth
		const skillClustersToDisplay = currentTabContainer.querySelectorAll('[data-toggle-target]');
		for (let i = 0; i < skillClustersToDisplay.length; i += 1) {
			if (skillClustersToDisplay[i].classList.contains('is-visible')) {
				skillClusterSelected += 1;
				break;
			}
		}
		// If no skillclusters are selected, show all skillclusters with skills
		if (skillClusterSelected <= 0) {
			skillClustersToDisplay.forEach((cluster) => {
				cluster.classList.add('is-visible');
			});
		}
	},

	selectAllCheckboxes(e, currentTab) {
		const { target } = e;
		const inputs = currentTab.querySelectorAll('input');
		if (target.innerText === target.dataset?.selectAllText) {
			inputs.forEach((input) => {
				input.checked = true;
			});
			target.innerText = target.dataset?.deselectText;
		} else {
			inputs.forEach((input) => {
				input.checked = false;
			});
			target.innerText = target.dataset?.selectAllText;
		}
	},

	async nextPrev(n, currentTabContainer) {
		// This function will figure out which tab to display
		// Exit the function if any field in the current tab is invalid:
		if (n === 1 && !this.validateForm()) return false;

		// Submit the form:
		await this.submitForm(currentTabContainer);
		if (this.continue === false) return false;

		// Hide the current tab:
		if (this.currentTab + 1 < this.tabs.length || n === -1) {
			currentTabContainer.style.display = 'none';
		}

		// Increase or decrease the current tab by 1:
		this.currentTab += n;
		// if you have reached the end of the form... :
		if (this.currentTab >= this.tabs.length) {
			this.currentTab -= 1;
			return false;
		}

		// Otherwise, display the correct tab:
		this.showTab(this.currentTab);
		return false;
	},

	fixStepIndicator() {
		document.getElementById('steps').classList.remove('hide');
		// This function removes the "active" class of all steps...
		const steps = document.getElementsByClassName('step');
		for (let i = 0; i < steps.length; i += 1) {
			steps[i].className = steps[i].className.replace(' active', '');
		}
		// ... and adds the "active" class to the current step:
		const stepsContainer = document.getElementById('steps');
		stepsContainer.classList.remove('one', 'two', 'three');
		if (steps[this.currentTab].dataset.stepClass)
			stepsContainer.classList.add(steps[this.currentTab].dataset.stepClass);
		steps[this.currentTab].className += ' active';
	},

	validateForm() {
		let valid = true;
		const inputs = this.tabs[this.currentTab]?.querySelectorAll('input, textarea, select');
		if (inputs) {
			// A loop that checks every input field in the current tab:
			valid = ErrorHandling(inputs);
		}
		return valid; // return the valid status
	},
};
export { OnboardingFlow as default };
